
    <!-- Modal Container -->
    @if (isOpen()) {
    <div [class]="computedModalClasses()" (click)="onBackdropClick($event)">
      <!-- Backdrop -->
      @if (hasBackdrop) {
      <div [class]="computedBackdropClasses()"></div>
      }

      <!-- Modal Content -->
      <div
        #modalContent
        [class]="computedContentClasses()"
        (click)="$event.stopPropagation()"
        [attr.aria-modal]="true"
        [attr.aria-labelledby]="title ? 'modal-title' : null"
        [attr.aria-describedby]="'modal-content'"
        role="dialog"
        tabindex="-1"
        (keydown)="handleKeyDown($event)"
      >
        <!-- Glass shimmer effect -->
        <div
          class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden rounded-xl"
        >
          <div
            class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/10 to-transparent
                        transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                        transition-transform duration-1500 ease-out"
          ></div>
        </div>

        <!-- Premium floating particles -->
        @if (variant === 'premium') {
        <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-20 rounded-xl">
          <div class="absolute top-1/4 left-1/6 w-2 h-2 bg-primary-400/40 rounded-full animate-pulse"></div>
          <div
            class="absolute bottom-1/3 right-1/4 w-1.5 h-1.5 bg-white/30 rounded-full animate-pulse delay-1000"
          ></div>
          <div class="absolute top-3/4 left-3/4 w-1 h-1 bg-primary-300/50 rounded-full animate-pulse delay-2000"></div>
        </div>
        }

        <!-- Modal Header -->
        @if (hasHeader) {
        <div [class]="computedHeaderClasses()">
          <div class="relative z-10 flex items-center space-x-3">
            @if (icon) {
            <div [class]="iconContainerClasses()">
              <ui-icon [name]="icon" size="lg" [customClass]="iconClasses()"></ui-icon>
            </div>
            }
            <div>
              @if (title) {
              <h2 id="modal-title" class="text-xl font-semibold text-white">
                {{ title }}
              </h2>
              } @if (subtitle) {
              <p class="mt-1 text-sm text-slate-300">
                {{ subtitle }}
              </p>
              }
            </div>
          </div>

          @if (showCloseButton) {
          <button
            (click)="close()"
            class="relative z-10 inline-flex items-center justify-center rounded-2xl border border-blue-200/18 bg-slate-900/35 p-2 text-slate-300 transition-all duration-200 hover:border-blue-200/28 hover:bg-white/8 hover:text-white
                         focus:ring-2 focus:ring-primary-500/50 focus:outline-none"
            [attr.aria-label]="'Close ' + (title || 'modal')"
          >
            <ui-icon name="x" size="md"></ui-icon>
          </button>
          }

          <!-- Header glass accent -->
          <div
            class="absolute inset-0 bg-linear-to-r from-primary-500/5 to-transparent
                          opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-t-xl"
          ></div>
        </div>
        }

        <!-- Modal Content (only show if there's input or projected content) -->
        <ng-container #contentCheck>
          <ng-content></ng-content>
        </ng-container>

        @if (hasInput || hasProjectedContent) {
        <div [class]="computedModalContentClasses()" id="modal-content">
          <div class="relative z-10">
            <!-- Input field (if hasInput is true) -->
            @if (hasInput) {
            <div class="mb-4">
              @if (inputLabel) {
              <label class="mb-2 block text-sm font-medium text-slate-200">
                {{ inputLabel }}
                @if (inputRequired) {
                <span class="text-red-500">*</span>
                }
              </label>
              }
              <input
                type="text"
                [(ngModel)]="inputModel"
                [placeholder]="inputPlaceholder"
                [required]="inputRequired"
                class="w-full rounded-xl border border-blue-200/18
                       bg-slate-900/42 px-4 py-2.5 backdrop-blur-sm
                       text-white placeholder-slate-400
                       focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500/50
                       transition-all duration-200"
                (keydown.enter)="confirm()"
              />
            </div>
            }

            <ng-content></ng-content>
          </div>
        </div>
        }

        <!-- Modal Footer -->
        @if (hasFooter) {
        <div [class]="computedFooterClasses()">
          <div class="relative z-10 flex items-center justify-end space-x-3">
            <ng-content select="[slot=footer]"></ng-content>

            @if (!hasCustomFooter) { @if (showCancelButton) {
            <ui-button-glass
              variant="ghost"
              size="md"
              (click)="cancel()"
            >
              {{ cancelLabel }}
            </ui-button-glass>
            } @if (showConfirmButton) {
            <ui-button-glass
              [variant]="getConfirmButtonVariant()"
              size="md"
              (click)="confirm()"
            >
              {{ confirmLabel }}
            </ui-button-glass>
            } }
          </div>

          <!-- Footer glass accent -->
          <div
            class="absolute inset-0 bg-linear-to-r from-transparent to-primary-500/5
                          opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-xl"
          ></div>
        </div>
        }

        <!-- Modal glow effect -->
        @if (variant === 'premium' || variant === 'danger' || variant === 'success') {
        <div class="absolute inset-0 rounded-xl opacity-30 pointer-events-none">
          <div [class]="glowClasses()"></div>
        </div>
        }
      </div>
    </div>
    }
  
